const CHAT_LOCAL_STORAGE_CONVERSATION_DATA_KEY = 'CHAT_CONVERSATION';
const CHAT_LOCAL_STORAGE_CHAT_USER = 'CHAT_USER';
const CHAT_LOCAL_STORAGE_CHAT_USER_TOKEN_KEY = 'CHAT_USER_TOKEN';
const CHAT_LOCAL_STORAGE_CHAT_BABY_AGE_KEY = 'CHAT_BABY_AGE';
const CHAT_LOCAL_STORAGE_CHAT_LIMIT_REACHED_KEY = 'CHAT_LIMIT_REACHED';
const DEFAULT_AGE = 1;
const CHAT_ERROR_REACHED_LIMIT = '(Streaming) Error: Reached interaction limit';

export {
  DEFAULT_AGE,
  CHAT_LOCAL_STORAGE_CONVERSATION_DATA_KEY,
  CHAT_LOCAL_STORAGE_CHAT_USER,
  CHAT_LOCAL_STORAGE_CHAT_USER_TOKEN_KEY,
  CHAT_LOCAL_STORAGE_CHAT_BABY_AGE_KEY,
  CHAT_LOCAL_STORAGE_CHAT_LIMIT_REACHED_KEY,
  CHAT_ERROR_REACHED_LIMIT,
};
